const update = {
  productDetails: (product, container) => {
    const productID = container.find('#productID'); // for back in stock
    productID.val(product.id);

    container.attr('data-pid', product.id);

    const productName = container.find('.product-name');
    productName.text(product.productName);

    const productNameBrand = container.find('.product-name-brand');
    productNameBrand.text(product.brand);

    const productDescription = container.find('.product-description');
    productDescription.empty().html(product.shortDescription);

    const productAvailability = container.find('.product-availability');
    productAvailability.attr('data-ready-to-order', product.readyToOrder).attr('data-available', product.available);

    const productAvailabilityMsg = container.find('.stock-message');
    const availabilityItems = product.availability.messages;
    if (availabilityItems.length >= 0) {
      productAvailabilityMsg.text(availabilityItems[0].msg);
    }

    const $subscriptionPriceContainer = $('.sor-price-container');
    if (!product.multiPack.length) {
      if (product.price.sorPrice.formatted) {
        if ($subscriptionPriceContainer.hasClass('d-none')) {
          $subscriptionPriceContainer.removeClass('d-none');
        }
        const $subscriptionPriceValue = $subscriptionPriceContainer.find('.sor-price-container-value');

        if ($subscriptionPriceValue.length) {
          $subscriptionPriceValue.html(product.price.sorPrice.formatted);
          $subscriptionPriceValue.attr('content', product.price.sorPrice.decimalPrice ? product.price.sorPrice.decimalPrice : '');

          const $mainPrice = $('.details-container .sales .value, .sticky-add-to-cart .sales .value');
          const $savingValue = $('.smart-order-refill__saving-value');
          const savings = parseFloat($mainPrice.attr('content')) - parseFloat($subscriptionPriceValue.attr('content'));
          const currencySymbol = $subscriptionPriceValue.html().replace($subscriptionPriceValue.attr('content').replace('.', ','), '');
          $savingValue.html(`${currencySymbol} ${savings.toFixed(2).replace('.', ',')}`);
        }
      } else {
        $subscriptionPriceContainer.addClass('d-none');
      }
    }

    const detailsDescription = container.find('.description-and-detail');
    detailsDescription.empty().html(product.attributeProductHtml);
    detailsDescription.find('table').each((index, elem) => {
      $(elem).removeAttr('style').addClass('table table-bordered table-striped');
      $(elem).find('tr').removeAttr('style');
      $(elem).find('td').removeAttr('style');
      if (!$(elem).closest().hasClass('table-responsive')) {
        $(elem).wrap('<div class="table-responsive" />');
      }
    });

    if (!product.price.discount) {
      $('.primary-slider').find('.discount').hide();
    } else {
      const discountWrapper = $('.primary-slider').find('.discount');
      const discount = product.price.discount.toFixed(0);

      if (!discountWrapper.length) {
        $('.leaf.discount').text(`-${discount}%`);
      } else {
        discountWrapper.empty().text(`-${discount}%`).show();
      }
    }

    // Rebuild quantity selector with new variation's quantities
    if (product.quantities && product.quantities.length > 0) {
      const $quantitySelect = container.find('.quantity-select');
      if ($quantitySelect.length) {
        const isUserQuantityChange = container.attr('data-user-quantity-change') === 'true';
        $quantitySelect.empty();
        let selectedValue = null;

        product.quantities.forEach((qty) => {
          const $option = $('<option></option>').attr('value', qty.value).text(qty.value);

          if (qty.url) {
            $option.attr('data-url', qty.url);
          }

          if (qty.selected) {
            $option.attr('selected', 'selected');
            selectedValue = qty.value;
          }

          $quantitySelect.append($option);
        });

        if (!selectedValue) {
          const $firstOption = $quantitySelect.find('option').first();
          if ($firstOption.length) {
            $firstOption.prop('selected', true);
            selectedValue = $firstOption.val();
          }
        }

        // Keep user-entered quantity on +/- changes; sync only on landing/variant refresh.
        if (selectedValue && !isUserQuantityChange) {
          container.find('.input-quantity, .qv-input-quantity').val(selectedValue);
        }

        if (isUserQuantityChange) {
          container.removeAttr('data-user-quantity-change');
        }
      }
    }
  },
  productPriceWithMultiPack: (response, eventContainer = null) => {
    const isQuickViewShown = $('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show');
    const $eventContainer = eventContainer && eventContainer.jquery ? eventContainer : $(eventContainer);
    const $setItemContainer = $eventContainer.length ? $eventContainer.closest('.product-detail.set-item') : $();
    let productContainer = isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');

    if ($setItemContainer.length) {
      productContainer = $setItemContainer;
    }

    const $priceSelector = productContainer.find('.details-container .prices .price, .sticky-add-to-cart .prices .price');
    const priceContainer = $priceSelector.closest('.prices');
    const $multiPackCarousel = productContainer.find('#multi-pack');

    if (response.redPrice) {
      priceContainer.addClass('text-red');
    } else {
      priceContainer.removeClass('text-red');
    }

    if ($multiPackCarousel.length > 0) {
      const $activeCell = productContainer.find('.multi-pack-items.is-active');
      const $discountPrice = productContainer.find('.details-container .sales .value, .sticky-add-to-cart .sales .value');

      if ($activeCell.length) {
        const unit = $activeCell.attr('data-unit-content');
        const unitPrice = $activeCell.attr('data-unitprice');
        $discountPrice.empty().attr('content', unit).html(unitPrice);

        const $saving = productContainer.find('.details-container .discount-value-multipack');
        if ($saving.length > 0) {
          const savingValue =
            parseFloat(productContainer.find('.details-container .strike-through .value').attr('content')) -
            parseFloat(productContainer.find('.details-container .sales .value').attr('content'));
          const finalValue = parseFloat(savingValue).toFixed(2).toString().replace('.', ',');
          $saving.empty().html(finalValue + $multiPackCarousel.attr('data-currency-symbol'));
        }

        const $subscriptionPriceContainer = productContainer.find('.sor-price-container');
        const $subscriptionPriceValue = $subscriptionPriceContainer.find('.sor-price-container-value');
        const $savingValue = productContainer.find('.smart-order-refill__saving-value');

        if (response.price && response.price.sorPrice && response.price.sorPrice.formatted) {
          if ($subscriptionPriceContainer.hasClass('d-none')) {
            $subscriptionPriceContainer.removeClass('d-none');
          }
          const subsPrice = $activeCell.attr('data-unitprice-subscription');
          const subsPriceContent = $activeCell.attr('data-unit-subscription');
          const subsSaving = $activeCell.attr('data-subscription-save');

          if (subsPrice !== $discountPrice.html()) {
            $subscriptionPriceValue.html(subsPrice);
            $subscriptionPriceValue.attr('content', subsPriceContent);
            $savingValue.html(subsSaving);
            // update.setSorCostPerPrice(response, subsPrice);
          }
        } else {
          if (!$subscriptionPriceContainer.hasClass('d-none')) {
            $subscriptionPriceContainer.addClass('d-none');
          }
        }
      } else {
        $priceSelector.replaceWith(response.price.html);
      }
      update.setMultipackCostPerKg(response, response.idt_nascondi_prezzo_unitario, productContainer);
    } else {
      $priceSelector.replaceWith(response.price.html);
    }
  },

  setMultipackCostPerKg: function (productData, hidePricePerKilo, productContainer) {
    if (!document.querySelectorAll('.multi-pack-items.is-active') || !productData) return;

    const $scope = productContainer && productContainer.length ? productContainer : $('.product-detail').first();
    const costPerKgContainer = $scope.find('.product-qfis').first()[0];
    const multiPackCostPerKg = update.calculateMultipackCostPerKg(productData);

    if (!multiPackCostPerKg && multiPackCostPerKg === 0) return;

    const idtQfis = productData['idt-qfis'];
    const idtCumd = productData['idt-cumd'];
    const formattedMultiPackCostPerKg = multiPackCostPerKg
      .toLocaleString('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      .replace(/\s+/g, '');
    const multiPackCostPerKgText = `(${formattedMultiPackCostPerKg}/${idtCumd})`;

    if (!costPerKgContainer) {
      const priceContainer = $scope.find('.details-top > .prices').first()[0];

      if (priceContainer) {
        priceContainer.insertAdjacentHTML(
          'beforeend',
          `<p class="product-qfis ml-2" data-idt-qfis="${idtQfis}" data-idt-cumd="${idtCumd}">${multiPackCostPerKgText}</p>`
        );
      }
    } else {
      costPerKgContainer.innerHTML = multiPackCostPerKgText;
      costPerKgContainer.setAttribute('data-idt-qfis', idtQfis);
      costPerKgContainer.setAttribute('data-idt-cumd', idtCumd);
    }
    $scope.find('.product-qfis').toggle(hidePricePerKilo !== true);
  },

  calculateMultipackCostPerKg: function (productData) {
    /**
     * CPkg =  productCPkg - (productCPkg / 100 X multiPackPercentage)
     * CPkg: multipack cost per kg
     * productCPkg: product cost per kg
     * multiPackPercentage: multipack percentage
     */
    if (!productData || (productData && (!productData['idt-qfis'] || !productData.multiPack))) return 0;

    const multiPackArr = productData.multiPack;
    const multiPackItemsTotal = multiPackArr.length;
    const salesPrice = productData.price.sales.value;
    const productCPkg = salesPrice / productData['idt-qfis'];
    let multiPackItem = [];

    for (let index = 0; index < multiPackItemsTotal; index++) {
      multiPackItem = multiPackArr[index].row.filter((item) => item.quantity === productData.selectedQuantity);
    }

    if (!multiPackItem.length) return 0;

    const multiPackPercentage = (((salesPrice - multiPackItem[0].unitPrice) / salesPrice) * 100).toFixed(0);

    return productCPkg - (productCPkg / 100) * multiPackPercentage;
  },

  setSorCostPerPrice: function (productData = null, sorPrice = null) {
    const productRefillOptions = $('.product-refill-options');
    const $subscriptionPriceValue = $('.sor-price-container-value').text();
    if (!productRefillOptions.length) return;

    let subsPrice = sorPrice;
    let productQfis = productData ? productData['idt-qfis'] : null;
    let productCumd = productData ? productData['idt-cumd'] : null;

    if (!subsPrice) {
      const $activeCell = $('.multi-pack-items.is-active');
      if ($activeCell.length) {
        subsPrice = $activeCell.attr('data-unitprice-subscription');
      } else {
        subsPrice = productRefillOptions.data('sor-price');
      }
    }

    if (!productData) {
      const productQfisElement = document.getElementsByClassName('product-qfis')[0];
      if (productQfisElement) {
        productQfis = productQfisElement.getAttribute('data-idt-qfis') || null;
        productCumd = productQfisElement.getAttribute('data-idt-cumd') || null;
      }
    }

    if (!productQfis || !productCumd) return;

    const subsPriceWithoutCurrency = subsPrice.toString().replace(/(\d+),(\d+)[\s\S]*/g, '$1.$2');
    const currencySymbol = $subscriptionPriceValue.toString().slice(-1);
    const costPerPrice = `${(subsPriceWithoutCurrency / productQfis).toFixed(2)}${currencySymbol}/${productCumd}`;
    $('.sor-costPerKg-container-value').html(`(${costPerPrice.replace('.', ',')})`);
  }
};

export default update;
